module.exports = __webpack_public_path__ + "img/btn_xuanzhuan.36bde616.png";